<template>
    <div id="detail">
        <div class="header">
            <div class="title">{{$t("message.teamGramDetail")}}</div>
            <div class="subtitle">{{$t("message.manageYourTeamGramIntegration")}}</div>
        </div>
        <UpdateTeamGramChannel :channel="clone" />
    </div>
</template>
<script>
import UpdateTeamGramChannel from "../UpdateTeamGramChannel.vue";
import _ from "lodash";

export default {
    name: "Detail",
    components: {
        UpdateTeamGramChannel,
    },
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data: function () {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
};
</script>
<style scoped lang="scss">
.header {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;

    border-bottom: 1px solid var(--color-border-default);

    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--color-text-strong-default);
        padding-left: 5px;
    }

    .subtitle {
        font-size: 14px;
        color: var(--color-text-strong-default);
    }
}
</style>
